import { useEffect } from "react";

const SectionCategoryDetails = (props: any) => {
  const { data } = props;

  const exibirDetails = () => {
    return (
      <div className="flex sm:px-0 w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] mt-8 mb-20">
        <div className="flex flex-col lg:flex-row text-justify items-center gap-10 p-2 bg-primary-50 dark:bg-gray-600 rounded-3xl">

          {/* <span className="flex w-full text-justify">
            {data?.descriptionCategory ? data.descriptionCategory : "Sem descrição"}
          </span> */}

          <div
            className="w-full"
            dangerouslySetInnerHTML={{
              __html: data?.descriptionCategory
                ? data.descriptionCategory
                : "Sem descrição",
            }}
          ></div>

          <iframe
            className="shadow-2xl w-[18rem] sm:w-[30rem] lg:w-[50rem] h-[12rem] sm:h-[17.9rem] rounded-3xl lg:mr-[-10%]"
            width="1980"
            height="1024"
            src={data?.urlCategory ? data.urlCategory : ""}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>
    );
  };

  return <div className="flexCard mt-5">{exibirDetails()}</div>;
};

export default SectionCategoryDetails;
